import { Link } from "react-router-dom"
import styles from "./SiteLogo.module.css"

type SiteLogoProps = {
  as?: "link" | "heading"
}

export function SiteLogo({ as = "link" }: SiteLogoProps) {
  const content = (
    <>
      <img
        src="/logo-100.png"
        srcSet="/logo-100.png 100w, /logo-512.png 512w"
        sizes="50px"
        alt=""
        width={50}
        height={50}
        className={styles.mark}
        decoding="async"
      />
      <span className={styles.text}>株主優待図鑑</span>
    </>
  )

  if (as === "heading") {
    return <h1 className={styles.logo}>{content}</h1>
  }

  return (
    <Link to="/" className={styles.logo}>
      {content}
    </Link>
  )
}
